import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { CommissionType } from '../ShoppingCartSliceV2';

const useUpdateCommissionNeeded = () => {
  const { ShoppingCartV2, agent_commission }: any = useSelector(
    (state: RootState) => state.shoppingCartV2
  );
  const isUpdateCommissionNeeded = () => {
    const current = ShoppingCartV2?.agent_commission;
    if (!current) {
      return false;
    }
    const sameType = agent_commission.type === current.type;

    if (!sameType) {
      // type changed → commission changed
      return true;
    }

    if (agent_commission.type === CommissionType.PerPax) {
      // PerPax comparison
      return agent_commission.per_pax !== current.per_pax;
    }
    // Percentage comparison
    return agent_commission.percentage !== current.percentage;
  };

  return isUpdateCommissionNeeded;
};

export default useUpdateCommissionNeeded;
